module.exports = __webpack_public_path__ + "img/topup_grey_desktop.939d259e.svg";